(function autoCloseDetails() {
  document.addEventListener('click', function (event) {
    const detailsToClose = [...document.querySelectorAll('details[data-auto-close-details][open]')].filter(
      (element) => {
        const closingOn = window.innerWidth < 750 ? 'mobile' : 'desktop';
        return (
          element.getAttribute('data-auto-close-details')?.includes(closingOn) &&
          !(event.target instanceof Node && element.contains(event.target))
        );
      }
    );

    for (const detailsElement of detailsToClose) detailsElement.removeAttribute('open');
  });
})();

class InfiniteAnnouncementBar {
  constructor() {
    this.tracks = document.querySelectorAll('.announcement-bar__track');
    this.init();
  }

  init() {
    this.tracks.forEach(track => {
      this.setupInfiniteScroll(track);
    });
  }

  setupInfiniteScroll(track) {
    const speed = parseInt(track.dataset.speed) || 15; // seconds for full cycle
    const container = track.parentElement;
    
    // Clone the content multiple times for smooth infinite scroll
    this.cloneContent(track, 3); // Clone 3 times for smooth transition
    
    // Calculate total width and set animation
    const totalWidth = track.scrollWidth;
    const containerWidth = container.offsetWidth;
    const itemWidth = totalWidth / 4; // Since we have original + 3 clones
    
    // Set CSS custom properties for animation
    track.style.setProperty('--total-width', `${totalWidth}px`);
    track.style.setProperty('--item-width', `${itemWidth}px`);
    track.style.setProperty('--animation-duration', `${speed}s`);
    
    // Add the CSS animation
    track.style.animation = `scroll-infinite ${speed}s linear infinite`;
    
    // Add pause on hover functionality
    container.addEventListener('mouseenter', () => {
      track.style.animationPlayState = 'paused';
    });
    
    container.addEventListener('mouseleave', () => {
      track.style.animationPlayState = 'running';
    });
    
    // Handle window resize
    window.addEventListener('resize', () => {
      this.handleResize(track);
    });
  }

  cloneContent(track) {
    const items = Array.from(track.children);
    
    // Clone the items 3 times for smooth infinite scroll
    for (let i = 0; i < 3; i++) {
      items.forEach(item => {
        const clone = item.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true'); // Hide from screen readers
        track.appendChild(clone);
      });
    }
  }

  handleResize(track) {
    // Recalculate widths on resize
    const container = track.parentElement;
    const totalWidth = track.scrollWidth;
    const containerWidth = container.offsetWidth;
    
    track.style.setProperty('--total-width', `${totalWidth}px`);
  }
}

// Add the CSS animation keyframes dynamically
const style = document.createElement('style');
style.textContent = `
  @keyframes scroll-infinite {
    0% {
      transform: translateX(0);
    }
    100% {
      transform: translateX(calc(-1 * var(--item-width, -25%)));
    }
  }
`;
document.head.appendChild(style);

// Initialize when DOM is loaded
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new InfiniteAnnouncementBar();
  });
} else {
  new InfiniteAnnouncementBar();
}

// Also initialize on page navigation (for SPA behavior)
document.addEventListener('shopify:section:load', () => {
  new InfiniteAnnouncementBar();
});
